// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentReasons_container__qsMxE"};